import mirrorCreator from "mirror-creator";

export default mirrorCreator(["ADD", "UPDATE", "REMOVE", "REMOVE_ALL"]);
